import React, { useContext } from "react";
import { CommandBarButton } from "sprint-common-web";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { useAccessVerifier } from "../../../../core/security/useAccessVerifier";

export interface OrderWorkflowsButtonProps {
    processingExecutionArn: string | undefined;
    deliveryExecutionArn: string | undefined;
}

export const OrderWorkflowsButton: React.VFC<OrderWorkflowsButtonProps> = ({
    processingExecutionArn,
    deliveryExecutionArn
}: OrderWorkflowsButtonProps) => {
    const { baseExecutionDetailsUri } = useContext(AppConfigContext);
    const { isAuthorized: isUserAuthorizedToUseAction } = useAccessVerifier();

    const isAuthorized = isUserAuthorizedToUseAction([SprintAccessRight.MonitRead]);

    if (!isAuthorized) {
        return <></>;
    }

    const goToProcessingExecutionDetails = () => {
        window.open(`${baseExecutionDetailsUri}/${processingExecutionArn}`);
    };

    const goToDeliveryExecutionDetails = () => {
        window.open(`${baseExecutionDetailsUri}/${deliveryExecutionArn}`);
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdAdmin]}>
            <CommandBarButton
                text="Workflows"
                icon="Dataflows"
                testId="order-workflows-button"
                menuItems={[
                    {
                        text: "Processing",
                        icon: "Processing",
                        disabled: !processingExecutionArn,
                        onClick: goToProcessingExecutionDetails
                    },
                    {
                        text: "Delivery",
                        icon: "CloudUpload",
                        disabled: !deliveryExecutionArn,
                        onClick: goToDeliveryExecutionDetails
                    }
                ]}
            ></CommandBarButton>
        </AuthorizationWrapper>
    );
};
